import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import ShowIcon from '@interxfi/design-system/icons/react/icon-show';
import { PageTabRail } from '../../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../../components/router/router-tabbed-navigation';
import { DocgenPreviewMonthlyStatementDrawer } from '../../../../../../../../../../../features/generate/monthly-statement/docgen-preview-monthly-statement-drawer';
import { DocgenMonthlyStatementTasksTable } from '../../../../../../../../../../../features/generate/monthly-statement/task/docgen-monthly-statement-tasks-table';
import { getPageHead } from '../../../../../../../../../../../util/routing/meta';
import { useRollupViewContext } from '../../../../../../../../../../../util/view-context';

export const Route = createFileRoute(
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/monthly-statement/task/_task/',
)({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingOperationsDocGenMonthlyStatement,
      label: 'Tasks',
      order: 1,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingOperationsDocGenMonthlyStatement>,
  head: () => getPageHead('Monthly Statement Tasks'),
  component: DocgenMonthlyStatementEntryList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          <RequiresAccess write>
            <DocgenPreviewMonthlyStatementDrawer
              trigger={<Button affixIcon={<ShowIcon aria-hidden />} aria-label="Preview" size="small" variant="primary" />}
            />
          </RequiresAccess>
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingOperationsDocGenMonthlyStatement}
    />
  );
}

function DocgenMonthlyStatementEntryList() {
  const viewContext = useRollupViewContext();

  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <DocgenMonthlyStatementTasksTable HeaderActions={TableHeader} view={viewContext} />
      </PageLayout.Section>
    </PageLayout>
  );
}
